// http://localhost:4200/#/
// URL can contain some data prepended with a # character.
// The # part of the URL is called the hash fragment.
// Another way to think about the hash fragment, since it's never sent to the server,
// is that it's for storing the state of your client application.

import {
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-bootstrap-spinner";
import { Subscription } from "rxjs";
import { LayoutService } from "src/app/shared/services/layout.service";
import { AuthenticationService } from "../../../shared/services/authService";
import { APIService } from "../../APIService";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  @ViewChild("hideDiv") hideDiv: ElementRef;
  hmacEnabled = true;
  loginForm: FormGroup;
  alertPopUp = false;
  errorText = "";
  whiteSpaceRegex = /^\S*$/;
  emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  copyRightYear = "";
  errorMessage = "";
  subscriptions: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private _authService: AuthenticationService,
    private _layoutService: LayoutService,
    private spinner: NgxSpinnerService,
    private _router: Router,
    private _apiService: APIService
  ) {
    this.loginForm = this.formBuilder.group({
      userName: [
        "",
        [Validators.required, Validators.pattern(this.whiteSpaceRegex)],
      ],
      password: ["", [Validators.required]],
      secret_key: [""],
      user_key: [""],
    });

    this.subscriptions.push(
      this._authService.getCopyrightYear().subscribe((copyRightYear) => {
        this.copyRightYear = copyRightYear;
      })
    );

    this.subscriptions.push(
      this._authService.ErrorMessage.subscribe((errorMessagee) => {
        this.errorMessage = errorMessagee;
      })
    );

    this.subscriptions.push(
      this._layoutService.HMACEnabled.subscribe((enabled) => {
        this.hmacEnabled = enabled;
      })
    );
  }

  FocusEvent() {
    if (this.hideDiv && this.hideDiv.nativeElement) {
      setTimeout(() => {
        this.hideDiv.nativeElement.style.display = "none";
      }, 2000);
    }
  }

  Login() {
    if (this.loginForm.valid) {
      this._authService.ErrorMessage.next("");
      this.spinner.show("loginSpinner");
      this._authService.loginUser(this.loginForm.value).subscribe(
        (result) => {
          if (result.status == "ok") {
            // console.log("here");
            this.spinner.hide("loginSpinner");

            sessionStorage.setItem(
              "currentUser_EPC_Portfolio",
              JSON.stringify(result.token)
            );
            sessionStorage.setItem(
              "secretKey",
              JSON.stringify(this.loginForm.value.secret_key)
            );
            sessionStorage.setItem(
              "userKey",
              JSON.stringify(this.loginForm.value.user_key)
            );

            // // Navigate to Dashboard Component
            // this._router.navigate(["pages"]);
            this.getAllLogData();

            // No need right now
            // let params = {
            //   data: { userName: this.loginForm.value.userName },
            //   hmac_sig: result.h_macc,
            //   u_key: result.u_lkey,
            //   timestamp: result.timestamp
            // }
            // this._authService.getUserByEmail(params).subscribe(data => {
            //   if (data && data.username == this.loginForm.value.userName) {
            //   } else {
            //     this._router.navigate(["../logout"]);
            //   }
            // }, err => {
            //   this._router.navigate(["../logout"]);
            // });
          } else {
            this.spinner.hide("loginSpinner");
            if (result.err.status) {
              // console.log(result);
              this.HandleErrors(result.err.status, result.err.statusText);
            }
            return;
          }
        },
        (error) => {
          this.HandleErrors(error.status, error.statusText);
          return;
        }
      );
    }
  }

  getAllLogData() {
    this._authService.ErrorMessage.next("");
    this.spinner.show("loginSpinner");

    const sub = this._apiService
      .getAllLogData()
      .pipe(finalize(() => this.spinner.hide("loginSpinner")))
      .subscribe({
        next: (response) => {
          if (response.status === "ok") {
            this._apiService.dataError.next(false);
            this._router.navigate(["pages"]);
          } else {
            this._apiService.dataError.next(true);
          }
        },
        error: (err) => {
          this.spinner.hide("loginSpinner");
          this.HandleErrors(err.status, err.error.error);
          this._apiService.dataError.next(true);
        },
      });
    this.subscriptions.push(sub);
  }

  changeType() {
    (document.getElementById("password") as any).type = "password";
  }

  ValidateKeys() {
    if (
      this.hmacEnabled &&
      !(
        this.loginForm.get("secret_key").value &&
        this.loginForm.get("user_key").value
      )
    ) {
      return true;
    } else return false;
  }

  isAuth() {
    const user = sessionStorage.getItem("currentUser_EPC_Portfolio");
    return !!user;
  }

  HandleErrors(status?, msg?) {
    console.log(status, msg);

    if (status == 0) {
      this._authService.ErrorMessage.next(
        "Service Temporarily Unavailable, please try again"
      );
    } else if (status == 400 || status == 401) {
      // this._authService.ErrorMessage.next(
      //   "Invalid Credentials." + (msg.toLowerCase() != "ok" ? " :" + msg : "")
      // );
      this._authService.ErrorMessage.next(
        msg.toLowerCase() != "ok"
          ? "Invalid credentials. Please check your login details and try again."
          : ""
      );
    } else {
      this._authService.ErrorMessage.next(
        "Internal Server Error" + (msg.toLowerCase() != "ok" ? " :" + msg : "")
      );
    }
  }

  showAlert(target) {
    this.alertPopUp = true;
    this.errorText = target;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
